module.exports = __webpack_public_path__ + "img/ssb_logo_square.beed665c.png";